import React from 'react';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import gradients from 'config/material-ui/gradients';
import { isAfter, isEqual, isBefore } from 'date-fns';
import useSchedulePreviewCalendarContext from '../context/useSchedulePreviewCalendarContext';

export default function TimeTableCellComponent({
  startDate,
  endDate,
  ...restProps
}: WeekView.TimeTableCellProps) {
  const { scheduleRanges } = useSchedulePreviewCalendarContext();

  const isWorkScheduleOverlapping = scheduleRanges.some((scheduleRange) => {
    if (
      !startDate ||
      !endDate ||
      !(scheduleRange.startDate instanceof Date) ||
      !(scheduleRange.endDate instanceof Date)
    ) {
      return false;
    }

    return (
      ((isAfter(scheduleRange.endDate, endDate) ||
        isEqual(scheduleRange.endDate, endDate)) &&
        isBefore(scheduleRange.startDate, startDate)) ||
      isEqual(scheduleRange.startDate, startDate)
    );
  });

  return (
    <WeekView.TimeTableCell
      data-end={endDate}
      data-start={startDate}
      {...restProps}
      style={{
        height: '5rem',
      }}
      sx={{
        background: isWorkScheduleOverlapping
          ? 'main.white'
          : gradients.GRAY_DIAGONAL_STRIPES,
        backgroundSize: '1.5rem 1.5rem',
      }}
    />
  );
}
